import ProductsTag from "@/components/templates/ArchiveTag/Products";
import { generateSEO } from "@/helpers/seo";
import { getData } from "@/lib/prismic/data";
import { cn } from "@/lib/utils";
import { ArchiveTableDocument, TagDocument } from "@/prismicio-types";
import { notFound } from "next/navigation";
import { use } from "react";

const ArchiveTag = ({ resolution }: TemplateProps) => {
  const document = use(getData({ ...resolution })) as TagDocument | null;

  if (!document || !document.data) return notFound();

  const { title } = document.data;

  return (
    <>
      <header className="container mt-8 space-y-6 px-4 xl:px-7.5">
        <h1
          className={cn("font-cabinet-grotesk leading-h1 text-start text-2xl font-medium md:text-4xl md:font-normal")}
        >
          {title}
        </h1>
      </header>

      <div className="container px-4 xl:px-7.5">
        <ProductsTag tag={document} locale={resolution.locale} />
      </div>
    </>
  );
};

export default ArchiveTag;

ArchiveTag.generateMetadata = async (resolution: Resolution) => {
  const document = (await getData({
    ...resolution,
  })) as ArchiveTableDocument | null;

  if (!document || !document.data) {
    return {};
  }

  return generateSEO(document, resolution.locale);
};
